<template>
<!-- Site wrapper -->
<div>
  <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
              <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
              <b-spinner class="ml-2" variant="danger"></b-spinner>
            </div>
            <form class="forms-sample">
              <div class="form-row">
                <div class="form-group col-md-12 col-lg-12 col-xl-6">
                  <label for="inputTipoAcesso" class="required">Tipo de Acesso</label>
                  <b-form-select
                    v-model="formulario.f_role"
                    :options="comboTiposAcesso"
                    value-field="valor"
                    text-field="label"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    class="form-control comboFonteDefault"
                    id="inputTipoAcesso">
                  </b-form-select>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_role}}</div>
                </div>
                <div class="form-group col-12">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                    <input
                      type="checkbox"
                      v-model="formulario.f_coordinator"
                      class="custom-control-input"
                      id="customSwitchCoordenador"
                      :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitchCoordenador">Coordenador</label>
                  </div>
                </div>
                <div class="form-group col-12">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                    <input
                      type="checkbox"
                      v-model="formulario.f_reviewer"
                      class="custom-control-input"
                      id="customSwitchRevisor"
                      :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitchRevisor">Revisor</label>
                  </div>
                </div>
                <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <label for="inputPerfil" class="required">Perfil</label>
                  <b-form-select
                    v-model="formulario.f_profiles"
                    :options="comboPerfis"
                    @change="montarEstruturaDoPerfil"
                    @input="trocarPerfil"
                    value-field="f_id"
                    text-field="f_name"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    class="form-control comboFonteDefault"
                    id="inputPerfil"/>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_profiles}}</div>
                </div>
                <div class="form-group col-12">
                  <Advogado v-if="layoutPerfil == 'Advogado'" />
                  <Estagiario v-if="layoutPerfil == 'Estagiario'" />
                  <Cliente v-if="layoutPerfil == 'Cliente'" />
                  <Correspondente v-if="layoutPerfil == 'Correspondente'" />
                </div>
                <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                  <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div> <!-- form-row ends -->
            </form>
          </div>
        </div> <!-- card ends -->
      </div>
    </div>
  </section> <!-- /.content -->
</div><!-- ./wrapper -->
</template>

<script>
import Perfil from './js/perfil'
export default Perfil
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
